import iconAlignLeft from "./align-left.svg";
import iconAlignCenter from "./align-center.svg";
import iconAlignRight from "./align-right.svg";

import iconBold from "./bold.svg";
import iconItalic from "./italic.svg";

import iconFill from "./fill.svg";
import iconTextHighlight from "./text-highlight.svg";

export const iconsAlignent = {
  left: iconAlignLeft,
  center: iconAlignCenter,
  right: iconAlignRight,
};

export const iconsFormatting = {
  bold: iconBold,
  italic: iconItalic,
};

export const iconsStyling = {
  fill: iconFill,
  highlight: iconTextHighlight,
};
